import {
    resolveFacetAutogenerateSource,
    type ResolveFacetAutogenerateSourceFailureReason,
} from "./resolve-facet-autogenerate-source";

export type BuildDsResult = { ds: Record<string, unknown> } | { errorMessage: string };

const AUTOGENERATE_SOURCE_ERRORS: Record<ResolveFacetAutogenerateSourceFailureReason, string> = {
    no_selection: "Select a data repo source in the sidebar.",
    invalid_type: "Select a data repo source with an Elasticsearch index.",
    no_es_index: "Selected data repo has no ES index configured.",
    invalid_id: "Invalid source selection.",
};

/** Builds `ds` for facets_autogenerate_etl from the selected sidebar source (data repo + ES index). */
export function buildDsForFacetAutogenerate(
    getNode: (id: string) => unknown,
    selectedSourceId: string | undefined,
    matrixKeys: string[]
): BuildDsResult {
    const resolved = resolveFacetAutogenerateSource(getNode, selectedSourceId);
    if (!resolved.ok) {
        return { errorMessage: AUTOGENERATE_SOURCE_ERRORS[resolved?.reason ?? "no_selection"] };
    }
    return {
        ds: {
            id: resolved.sourceId,
            type: "esindex",
            esindex_name: resolved.esIndex,
            matrix_keys: matrixKeys,
        },
    };
}
